import { useEffect, useState } from 'react';
import { getA2PRegistrationBannerStatus, } from 'shared-assets/lib/sdk/a2pRegistration';
import getSessionId from 'shared-assets/lib/utils/sessionId';
import rollbar from 'shared-assets/src/errors/errors';
export default function useA2PRegistrationBannerStatus() {
    var sessionId = String(getSessionId());
    var _a = useState({
        sessionId: sessionId,
        status: null,
    }), eligibility = _a[0], setEligibility = _a[1];
    useEffect(function () {
        var isMounted = true;
        getA2PRegistrationBannerStatus()
            .then(function (status) {
            if (isMounted)
                setEligibility({ sessionId: sessionId, status: status });
        })
            .catch(function (error) {
            if (isMounted) {
                setEligibility({ sessionId: sessionId, status: null });
                rollbar.warning('Unable to load A2P registration warning eligibility', error);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [sessionId]);
    return eligibility.sessionId === sessionId ? eligibility.status : null;
}
